<template>
    <div class="partner">
        <div>
            <div class="header_btn">
                <el-input class="common_ipt" v-model="interfaceName" placeholder="接口名称" clearable />
                <el-input class="common_ipt" v-model="interfaceRole" placeholder="接口作用" clearable />
                <el-input class="common_ipt" v-model="cycleCode" placeholder="记录标识" clearable />
                <el-select class="force-style-input" v-model="state" placeholder="状态" size="large" clearable
                    style="width: 200px;margin-right: 10px;">
                    <el-option label="成功" value="1" />
                    <el-option label="异常" value="2" />
                </el-select>
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始时间"
                    end-placeholder="结束时间" size="large" style="width: 270px;" clearable :disabled-date="disabledDate" />
                <el-button size="large" style="margin-left: 10px;" @click="resetBtn">重置</el-button>
                <el-button type="primary" size="large" style="margin-left: 10px;" :loading="searchState"
                    @click="searchBtn"><el-icon class="cancelgu">
                        <Search />
                    </el-icon>搜索</el-button>
            </div>
        </div>
        <div class="count">统计：{{ count }}条</div>

        <el-table :data="filterTableData" style="width: 100%;margin-bottom: 15px;" row-key="unionId" border
            :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts" v-loading="showLoading">
            <!-- 记录ID   -->
            <el-table-column fixed label="记录ID" prop="id" align="center" :show-overflow-tooltip='true' width="250">
            </el-table-column>
            <!-- 接口名称  -->
            <el-table-column label="接口名称 " prop="interfaceName" align="center" :show-overflow-tooltip='true'
                width="250">
            </el-table-column>
            <!-- 接口作用  -->
            <el-table-column label="接口作用 " prop="interfaceRole" align="center" :show-overflow-tooltip='true'
                width="250">
            </el-table-column>
            <!-- 状态  -->
            <el-table-column label="状态" align="center" width="130" :show-overflow-tooltip='true'>
                <template #default="scope">
                    <span v-if="scope.row.state == 1">成功</span>
                    <span v-if="scope.row.state == 2">异常</span>
                </template>
            </el-table-column>
            <!-- 接口状态码  -->
            <el-table-column label="接口状态码 " prop="interfaceStatus" align="center" :show-overflow-tooltip='true'
                width="130">
            </el-table-column>
            <!-- 接口信息  -->
            <el-table-column label="接口信息 " prop="msg" align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <!-- 记录标识  -->
            <el-table-column label="记录标识 " prop="cycleCode" align="center" :show-overflow-tooltip='true' width="220">
            </el-table-column>
            <!-- 创建时间  -->
            <el-table-column label="创建时间 " prop="createTime" align="center" :show-overflow-tooltip='true' width="160"
                :formatter="reach">
            </el-table-column>
        </el-table>
        <!-- 表格分页 -->
        <el-pagination hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 12, 18, 24]"
            :current-page="currentPage" :page-size="pagesize" :total="count" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
    </div>
</template>
<script setup>
import { Search } from '@element-plus/icons-vue'
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import moments from 'moment'
import {
    singleTaskData
} from "../../../../request/api";
import {
    useRouter,
} from "vue-router";
import qs from 'qs';
const showLoading = ref(true); //加载loading

const router = useRouter()
// 表格数据
const filterTableData = ref([]);
// 总计条数
const count = ref(0);
const interfaceName = ref('');  //接口名称
const interfaceRole = ref('');  //接口作用
const cycleCode = ref('');  //记录标识  
const time = ref([]);  // 时间，改为数组类型来接收日期范围
// 所属合作方
const state = ref('');
// 搜索状态
const searchState = ref(false);
// 分页
const currentPage = ref(1); // 当前页码
const pagesize = ref(6); // 每页显示条数
// 表格数据方法
const dataInfo = () => {
    let startTime = '';
    let endTime = '';
    if (time.value.length === 2) {
        // 获取开始日期的 00:00:00 时间戳
        startTime = Math.floor(moments(time.value[0]).startOf('day').valueOf() / 1000);
        // 获取结束日期的 23:59:59 时间戳
        endTime = Math.floor(moments(time.value[1]).endOf('day').valueOf() / 1000);
    }

    let params = {
        interfaceName: interfaceName.value, // 接口名称
        interfaceRole: interfaceRole.value, // 接口作用
        cycleCode: cycleCode.value, // 记录标识
        state: state.value,
        startTime: startTime,
        endTime: endTime,
        page: String(currentPage.value),
        limit: String(pagesize.value),
    }

    singleTaskData(qs.stringify(params)).then((res) => {
        if (res.data.code === 0) {
            filterTableData.value = res.data.data.interfaceLogPage.list;
            count.value = res.data.data.interfaceLogPage.totalCount;
            showLoading.value = false;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
};
// 禁用当天之后的日期
const disabledDate = (time) => {
    return time.getTime() > Date.now();
};
// 定义 reach 方法
const reach = (row, column, cellValue) => {
    // 这里可以添加格式化时间的逻辑
    if (cellValue) {
        return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
    }
    return '';
};
// 搜索
const searchBtn = () => {
    showLoading.value = true;
    currentPage.value = 1;
    dataInfo();
}
// 重置
const resetBtn = () => {
    interfaceName.value = '';
    interfaceRole.value = '';
    cycleCode.value = '';
    state.value = '';
    time.value = [];
    currentPage.value = 1;
    pagesize.value = 6;
    showLoading.value = true;
    dataInfo();
}
const handleSizeChange = (val) => {
    showLoading.value = true;
    pagesize.value = val;
    dataInfo();
}
const handleCurrentChange = (val) => {
    currentPage.value = val;
    showLoading.value = true;
    dataInfo();
}

onMounted(() => {
    dataInfo(); // 列表数据
})
</script>
<style lang="scss" scoped>
.common_ipt {
    width: 200px;
    margin-right: 10px;
}

.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover {
    color: #a0cfff;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.header_btn {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.count {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}



.force-style-input {
    height: 40px;
    line-height: 40px;
}

.common_btn {
    height: 39px;
    line-height: 39px;
    margin-left: 10px;
}

::v-deep .el-input__inner {
    height: 40px;
    line-height: 40px;
}

.cancelgu {
    margin-right: 6px;
    font-weight: bold;
}
</style>
